import React from 'react';
import classnames from 'classnames';
import ArrowUpSVG from '../../../../../images/svg/icons8-arrow-up';
import './presenters-list.scss';
import { IConnectionOption } from '../../../../../api/connections.dao';
import { IAttendeeOrganizationDTO } from '../../../../../api/attendees.dao';
import Text from '../../../../global/text/text';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import { REMOVE_TEXT } from '../../../../../constants/common-labels.constants';

interface IAttendeeOrganizationWithInhOrg extends IAttendeeOrganizationDTO {
    orgConnectionId?: number | null;
    inheritRoleConnectionId?: number | null;
    inhRoomRolePresenterConnectionOption?: IConnectionOption;
}

interface IOrgProps {
    name: string;
    optionValue?: string;
    isCancelled?: boolean;
    organizationId: string | number;
    isLabelVisibleCondition?: boolean;
    removeAttendee?: (organizationId) => void;
    getOptionItem?: (inheritRoleConnectionId) => IConnectionOption;
    disabled?: boolean;
}

const Organization = (props: IOrgProps) => {
    const {
        name,
        isCancelled,
        optionValue,
        organizationId,
        removeAttendee,
        disabled,
        isLabelVisibleCondition
    } = props;

    return (
        <div key={organizationId} className={classNames('presenters-list__row', {'presenters-list__disabled' : disabled})}>
            <Text tag='div' className='presenters-list__item' message={name} withEllipsis />
            {
                isLabelVisibleCondition
                ? (
                    <div className={classNames('connection-dropdown--inherit overflow-ellipsis',
                        { 'connection-dropdown--inherit--delete': isCancelled })}>
                        <ArrowUpSVG />
                        <Text message={optionValue} withEllipsis />
                    </div>
                )
                : null
            }
            {removeAttendee && <label
                onClick={() => removeAttendee(organizationId)}
                className='organization__remove-label'
            >
                <FormattedMessage {...REMOVE_TEXT} />
            </label>}
        </div>
    );
};

interface IProps {
    optionValue?: string;
    isCancelled?: boolean;
    isLabelVisibleCondition?: boolean;
    removeAttendee?: (attendeeId) => void;
    assignedPresenters: IAttendeeOrganizationDTO[] | IAttendeeOrganizationWithInhOrg[];
    getOptionItem?: (inheritRoleConnectionId) => IConnectionOption;
}

const PresentersList = (props: IProps) => {
    const {
        optionValue,
        isCancelled,
        removeAttendee,
        assignedPresenters,
        isLabelVisibleCondition
    } = props;
    return (
        <div className={classnames('presenters-list', { 'presenters-list--with-items' : assignedPresenters?.length })}>
            {
                assignedPresenters
                    .slice()
                    .sort((a, b) => a.name.localeCompare(b.name))
                    .map(presenter =>
                        <Organization
                            name={presenter.name}
                            isCancelled={isCancelled}
                            optionValue={optionValue}
                            key={presenter.organizationId}
                            removeAttendee={removeAttendee}
                            organizationId={presenter.organizationId}
                            isLabelVisibleCondition={isLabelVisibleCondition}
                        />
                 )
            }
        </div>
    );
};

export { Organization, PresentersList, IAttendeeOrganizationWithInhOrg };
